import React, { useState } from 'react';
import useSceneStore from '../store/useSceneStore';
import useShapeStore from '../store/useShapeStore';
import { SHAPE_CATALOG } from '../catalog/shapeCatalog';
import { TOOLS } from '../core/constants';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { clsx } from 'clsx';

const { FiTriangle, FiX } = FiIcons;

const ShapePanel = () => {
  const { tool } = useSceneStore();
  const { addShapeItem } = useShapeStore();
  const [isDragging, setIsDragging] = useState(null);

  if (tool !== TOOLS.SHAPE) return null;

  const handleDragStart = (e, item) => {
    setIsDragging(item);
    e.dataTransfer.setData('shapeItemId', item.id);
    const dragImage = document.createElement('div');
    dragImage.className = 'p-2 bg-white border border-[#1E2937] rounded shadow';
    dragImage.innerText = item.thumbnail + ' ' + item.name;
    document.body.appendChild(dragImage);
    e.dataTransfer.setDragImage(dragImage, 0, 0);
    setTimeout(() => document.body.removeChild(dragImage), 0);
  };

  const handleDragEnd = () => setIsDragging(null);

  return (
    <div className="absolute left-20 bottom-4 w-80 bg-white rounded-xl shadow-lg border border-gray-200 flex flex-col overflow-hidden z-10" style={{ maxHeight: 'calc(100vh - 100px)' }}>
      <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex items-center gap-2">
        <SafeIcon icon={FiTriangle} className="text-[#1E2937] text-lg" />
        <h3 className="font-semibold text-gray-700 text-sm">Kształty i Strzałki</h3>
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-6">
        {Object.entries(SHAPE_CATALOG).map(([key, category]) => (
          <div key={key} className="space-y-2">
            <h4 className="text-xs font-bold text-gray-500 uppercase">{category.name}</h4>
            <div className="grid grid-cols-2 gap-2">
              {Object.values(category.items).map(item => (
                <div 
                  key={item.id}
                  draggable
                  onDragStart={(e) => handleDragStart(e, item)}
                  onDragEnd={handleDragEnd}
                  className={clsx(
                    "p-3 border rounded-lg cursor-move hover:shadow-md transition-all bg-white flex flex-col items-center text-center gap-2",
                    isDragging?.id === item.id 
                      ? "border-[#1E2937] bg-gray-100 opacity-50" 
                      : "border-gray-200 hover:border-gray-400"
                  )}
                >
                  <div className="text-2xl">{item.thumbnail}</div>
                  <div className="text-xs font-medium text-gray-700">{item.name}</div>
                  <div className="text-[10px] text-gray-400">{item.dimensions.width/100}m × {item.dimensions.height/100}m</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="bg-gray-50 px-4 py-2 border-t border-gray-200 text-xs text-gray-500 text-center">
        Przeciągnij element na rzut
      </div>
    </div>
  );
};

export default ShapePanel;